<template>
  <div class="row p-4" id="btn-area">
    <div class="col-lg-6 col-md-6 col-xl-6 android_btn">
      <div class="form-group mt-3" :style="'text-align:right'">
        <a href="https://play.google.com/store/apps/details?id=com.gatetechs.topayme" target="_blank"
          class="button boxed-btn">
          <span><i aria-hidden="true" class="icofont-brand-android-robot"></i> {{ $t('app.android') }}</span>
        </a>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-xl-6 ios_btn">
      <div class="form-group mt-3">
        <a href="https://apps.apple.com/us/app/2-pay-me/id6448679192" target="_blank" class="button boxed-btn">
          <span><i aria-hidden="true" class="icofont-brand-apple"></i> {{ $t('app.ios') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Download",
  components: {},
  data() {
    return {};
  },
  mounted() {
    if (localStorage.getItem('locale') == 'ar') {
      // document.getElementById("btn-area").classList.add('is-rtl');
    }
  }
};
</script>

<style>
.ios_btn a,
.android_btn a {
  font-size: 15px;
  font-weight: 700;
  line-height: 0.5rem;
  width: 210px;
  background: #0255b2;
  color: #fff !important;
  display: inline-block;
  padding: 18px 44px;
  font-family: 'Almarai', sans-serif;
  border: 1px solid #0255b2;
  letter-spacing: 3px;
  text-align: center !important;
  text-transform: uppercase;
  cursor: pointer;
  height: 50px;
}
</style>